import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from "@blueprintjs/core";
import * as actions from '../../reducer/actions/index';
import { InputText } from 'primereact/inputtext';
import { axiosWithHeadersDownloadFile, axiosWithHeaders } from '../../reducer/contains/axiosWrapper'
import FormLayout from '../../components/form/index';
import { Calendar } from 'primereact/calendar';
import * as Status from '../../common/enum';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import { Tree } from 'primereact/tree';
import * as api from '../../reducer/contains/api'

import moment from 'moment';
var _ = require('lodash');

const Home = (props: any) => {
    const [dataReport, setDataReport] = React.useState<any>([
        {
            "key": 0,
            "label": "Danh sách báo cáo",
            "expanded": true,
            "children": [
                {
                    "key": 1,
                    "label": "Báo cáo chương trình",
                    "api": api.REPORT_ALL,
                    "namefile": "ReportAll.xlsx",
                    "method": "POST",
                    "validateFrom": false
                }
            ]
        }
    ]);
    const [dateFrom, setDateFrom] = React.useState();
    const [isLoading, setIsloading] = React.useState(false);
    const [showReport, setShowReport] = React.useState(false);
    const [dateTo, setDateTo] = React.useState();
    const [userId, setUserId] = React.useState(0);
    const [expandedKeys, setExpandedKeys] = React.useState({});
    const [title, setTitle] = React.useState('BÁO CÁO');
    const [id, setId] = React.useState(0);
    const [apiReport, setApiReport] = React.useState('');
    const [area, setArea] = React.useState('');
    const [nameFile, setNameFile] = React.useState('');
    // const ReportFormF = () => {
    //     setIsloading(true);
    //     let from = ''
    //     if (dateFrom !== undefined && dateFrom !== '' && dateFrom !== null)
    //         from = moment(dateFrom).format('YYYYMMDD')
    //     let to = ''
    //     if (dateTo !== undefined && dateTo !== '' && dateTo !== null)
    //         to = moment(dateTo).format('YYYYMMDD')
    //     axiosWithHeadersDownloadFile('POST', `${api.REPORT_FORM_F}`, { dateFrom: from, dateTo: to }, 'ReportFormF.xlsx')
    //         .then((data: any) => {
    //             setIsloading(false);
    //             // console.log(data)
    //         }).catch(err => {
    //             //  props.error_success('error', 'Lỗi', "Có lỗi xảy ra !" + err);
    //         });
    // }
    React.useEffect(() => {
       if( props.profile.roleId === 1 || props.profile.roleId ===2 ){
        let data = [
            {
                "key": 0,
                "label": "Danh sách báo cáo",
                "expanded": true,
                "children": [
                    {
                        "key": 1,
                        "label": "Báo cáo chương trình",
                        "api": api.REPORT_ALL,
                        "namefile": "ReportAll.xlsx",
                        "method": "POST",
                        "validateFrom": false
                    }
                  
                ]
            }
        ]
        setDataReport(data);
       }
        
        let _expandedKeys = { ...expandedKeys };
        _expandedKeys['0'] = true;
        setExpandedKeys(_expandedKeys);
    }, []);

   
    const onSelectItem = (event) => {
        const reportId = event.value;
        setId(event.value)
        if (reportId !== null) {
            const report = _.find(dataReport[0].children, function (item) { return item.key === reportId });
            setUserId(0);
            setDateFrom(undefined)
            setDateTo(undefined)
            setNameFile(report.namefile)
            setApiReport(report.api)
            setTitle(report.label)
            setShowReport(true)
          
        }
    }
    const DownloadReport = () => {
        setIsloading(true);
        let from = ''
        if (dateFrom !== undefined && dateFrom !== '' && dateFrom !== null)
            from = moment(dateFrom).format('YYYYMMDD')
        let to = ''
        if (dateTo !== undefined && dateTo !== '' && dateTo !== null)
            to = moment(dateTo).format('YYYYMMDD')
        axiosWithHeadersDownloadFile('POST', apiReport, { dateFrom: from, dateTo: to,supermarketId:0 }, nameFile)
            .then((response: any) => {
                setIsloading(false);
                // console.log(data)
            }).catch(err => {
                setIsloading(false);
                props.error_success('error', 'Lỗi', "Có lỗi xảy ra !" + err);
            });
    }
    return (
        <>
            <FormLayout formTitle="Báo Cáo">
                <div className='p-grid'>
                    <div className="col-4">
                        <Tree
                            value={dataReport as any}
                            selectionMode="single"
                            expandedKeys={expandedKeys}
                            onToggle={e => setExpandedKeys(e.value)}
                            onSelectionChange={(event) => onSelectItem(event)}
                          //  filter={true}
                        />
                    </div>
                    <div className='col-8'>
                        {showReport ? <>
                            <div className='col-12' >
                                <h2>{title}</h2>
                            </div>
                            <div className='col-12 row'>
                                <div className='p-col-4'>
                                    <Calendar
                                        value={dateFrom}
                                        onChange={(e: any) => setDateFrom(e.value)}
                                        placeholder="Chọn từ ngày"
                                        style={{ width: "100%" }}
                                        dateFormat="dd/mm/yy"
                                        //  readOnlyInput
                                        monthNavigator={true}
                                        yearNavigator={true}
                                        yearRange="2022:2025"
                                        className="filter-item"
                                    >
                                    </Calendar>
                                </div>
                                <div className='p-col-4'>
                                    <Calendar
                                        value={dateTo}
                                        onChange={(e: any) => setDateTo(e.value)}
                                        placeholder="Chọn đến ngày"
                                        style={{ width: "100%" }}
                                        dateFormat="dd/mm/yy"
                                        //  readOnlyInput
                                        monthNavigator={true}
                                        yearNavigator={true}
                                        yearRange="2022:2025"
                                        className="filter-item"
                                    >
                                    </Calendar>
                                </div>
                            </div>
                            <div className='col-12 row'>
                                <div className='col-12'>
                                    <Button icon="saved" onClick={() => DownloadReport()}  >
                                        <label>Tải báo cáo</label>
                                    </Button>
                                </div>
                            </div>

                            {isLoading ? <div className='col-12' style={{ margin: 'auto', display: 'flex' }} >
                                <ProgressSpinner />
                            </div> : null
                            }


                        </> : null}
                    </div>
                </div>

            </FormLayout>
        </>
    )

}

const mapDispatchToProps = dispatch => {
    return {
        error_success: (severity, summary, detail) => dispatch(actions.error_success(severity, summary, detail))
    }
}
const mapStateToProps = (state:any) => {
    return {
      profile:state.auth.profile
    }
  }
export default connect(mapStateToProps, mapDispatchToProps)(Home);
